module.exports = __webpack_public_path__ + "static/img/one.4dc34f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/one.png
// module id = TYBt
// module chunks = 1